import isServer from '../utils/isServer';
import parseCookie from '../utils/parseCookie';
import useServerContext from './useServerContext';

export const EDGE_EXPERIMENT_COOKIE = 'edge_experiments';
export const EXPERIMENT_HEADER = 'x-exp-cookie';

export interface ParsedEdgeExperimentsCookie {
  session_id: string;
  updated_at: string;
  [key: string]: CookieEdgeExperiment | string;
}

export interface CookieEdgeExperiment {
  feature_id: number;
  created_at: number;
  variant_name: string;
  variant_id: number;
  is_control: 0 | 1;
  user_type: string;
  is_edge?: boolean;
}

interface Election {
  isControl: boolean;
  isValid: boolean;
  variantId: number;
  variantName: string;
}

function electionFromExperiments(
  edgeExperiments: ParsedEdgeExperimentsCookie | null,
  featureName: string,
  isOnServer = false
): Election {
  // If there are no edgeExperiments, or the target feature is not present -- return invalid
  if (!edgeExperiments || !edgeExperiments[featureName]) {
    if (isOnServer) {
      console.log(
        'useEdgeExperiment - INVALID_ELECTION: edgeExperiments or feature does not exist'
      );
    }
    return INVALID_ELECTION;
  }

  const experiment = edgeExperiments[featureName];

  if (!experiment) {
    if (isOnServer) {
      console.log('useEdgeExperiment - INVALID_ELECTION: experiment does not exist');
    }
    return INVALID_ELECTION;
  }

  // Type safety to guarantee EdgeExperiment
  if (typeof experiment === 'string') {
    if (isOnServer) {
      console.log('useEdgeExperiment - INVALID_ELECTION: experiment is not a string');
    }
    return INVALID_ELECTION;
  }

  return {
    isControl: !!experiment.is_control,
    isValid: true,
    variantId: experiment.variant_id,
    variantName: experiment.variant_name,
  };
}

export const INVALID_ELECTION: Election = {
  isControl: true,
  isValid: false,
  variantId: 1,
  variantName: 'invalid',
};

export default function useEdgeExperiment(featureName: string): Election {
  const { serverContext } = useServerContext();
  const isOnServer = isServer();

  if (isOnServer) {
    const cookieString = serverContext?.req?.headers?.[EXPERIMENT_HEADER];

    // Type safety to guarantee presence of cookieString
    if (!cookieString || typeof cookieString !== 'string') {
      console.log('useEdgeExperiment - INVALID_ELECTION: cookieString is invalid');
      return INVALID_ELECTION;
    }

    const edgeExperiments = parseCookie(EDGE_EXPERIMENT_COOKIE, cookieString);
    const election = electionFromExperiments(edgeExperiments, featureName, isOnServer);
    console.log(
      'useEdgeExperiment SERVER - featureName:',
      featureName,
      'data:',
      JSON.stringify(election)
    );
    return election;
  } else {
    const edgeExperiments = parseCookie(EDGE_EXPERIMENT_COOKIE);
    return electionFromExperiments(edgeExperiments, featureName);
  }
}
